import { useEffect, useState } from 'react';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getLocalStorage, postWithoutToken } from '../../API/Api';
import { SESSION_PATHS } from '../../routes/paths';
import LOGO from '../../assets/images/comniqAI/comniq-logo-dark.svg';
import MOCKUP from '../../assets/images/comniqAI/mockup.svg';
import AuthLayout from './AuthLayout';
import { RiLockPasswordFill } from 'react-icons/ri';
import ButtonLoader from '../../components/ButtonLoader';

const ResetPassword = () => {
  const Navigate = useNavigate();
  const [showPwd1, setShowPwd1] = useState(false);
  const [showPwd2, setShowPwd2] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [values, setValues] = useState({
    password: '',
    confirm_password: '',
  });
  const { password, confirm_password } = values;
  const [formError, setFormError] = useState({});
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const email = getLocalStorage('userEmail');
    if (email) {
      setUserEmail(JSON.parse(email));
    }
  }, []);

  const handleChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  const handleClick = () => {
    let flag = true;
    setFormError({});

    if (!values.password) {
      setFormError((prev) => {
        return {
          ...prev,
          password: 'Password required',
        };
      });
      flag = false;
    }
    if (!values.confirm_password) {
      setFormError((prev) => {
        return {
          ...prev,
          confirm_password: 'Confirm Password required',
        };
      });
      flag = false;
    } else if (values.password && values.confirm_password && values.password !== values.confirm_password) {
      setFormError((prev) => {
        return {
          ...prev,
          confirm_password: "Password doesn't match",
        };
      });
      flag = false;
    }
    setLoader(true);

    let payload = {
      email: userEmail,
      new_password: password,
      confirm_password: confirm_password,
    };

    if (flag) {
      postWithoutToken('forgetpassword', payload)
        .then((response) => {
          if (response.status === 200) {
            toast.success(response.message);
            Navigate(SESSION_PATHS.LOGIN);
            localStorage.removeItem('userEmail');
            setValues('');
          } else if (response.status === 400) {
            toast.error(response.message);
          }
        })
        .catch((error) => {
          toast.error('Something went wrong');
        })
        .finally(() => {
          setLoader(false);
        });
    }
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <AuthLayout title='Reset password' subtitle='Back to' linkText='Sign in' linkTo={SESSION_PATHS.LOGIN} LeftImage={MOCKUP} Logo={LOGO}>
        <form onSubmit={onFormSubmit}>
          <div className='form-group position-relative input-GPT'>
            <label className='auth-label outfit-semibold'>Password*</label>
            <div className='input-with-icon'>
              <RiLockPasswordFill className='input-icon' />
              <input
                type={showPwd1 ? 'text' : 'password'}
                placeholder='**********'
                className='form-control auth-input'
                name='password'
                id='password'
                value={password}
                autoComplete='off'
                onChange={handleChange}
              />
              <button type='button' onClick={() => setShowPwd1(!showPwd1)} className='password-toggle-btn'>
                {showPwd1 ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
              </button>
            </div>
            {formError.password && <p className='text-danger insta-smart-error'>{formError.password}</p>}
          </div>

          <div className='form-group position-relative input-GPT'>
            <label className='auth-label outfit-semibold'>Confirm Password*</label>
            <div className='input-with-icon'>
              <RiLockPasswordFill className='input-icon' />
              <input
                type={showPwd2 ? 'text' : 'password'}
                placeholder='**********'
                className='form-control auth-input'
                name='confirm_password'
                id='confirm_password'
                value={confirm_password}
                autoComplete='off'
                onChange={handleChange}
              />
              <button type='button' onClick={() => setShowPwd2(!showPwd2)} className='password-toggle-btn'>
                {showPwd2 ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
              </button>
            </div>
            {formError.confirm_password && <p className='text-danger insta-smart-error'>{formError.confirm_password}</p>}
          </div>

          <div className='d-flex flex-wrap align-items-center justify-content-between gap-2 pt-2'>
            <button className='btn-submit-login outfit-bold max-width-100 d-flex align-items-center justify-content-center gap-2' onClick={handleClick}>
              {loader && <ButtonLoader />}
              <span className='outfit-bold'>Reset Password</span>
            </button>
          </div>
        </form>
      </AuthLayout>
    </>
  );
};

export default ResetPassword;
